import { getImageProps, type ImageProps } from "next/image";
import { cn } from "@/lib/utils";

/* next/image, minus the style="" attribute it always renders (color:transparent,
   plus absolute positioning for `fill`). A server-rendered style attribute would
   need 'unsafe-inline' in the CSP style-src (DAST-F360-010); the `fill` layout
   comes from the .img-fill class in globals.css instead. */
export function Image({ className, ...rest }: ImageProps) {
  const { props: { style: _style, ...props } } = getImageProps(rest);
  return <img {...props} className={cn(rest.fill && "img-fill", className)} />;
}
